import { render, staticRenderFns } from "./SandboxCatalogItemPage.vue?vue&type=template&id=4ef3ab34&scoped=true&"
import script from "./SandboxCatalogItemPage.vue?vue&type=script&lang=ts&"
export * from "./SandboxCatalogItemPage.vue?vue&type=script&lang=ts&"
import style0 from "./SandboxCatalogItemPage.vue?vue&type=style&index=0&id=4ef3ab34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef3ab34",
  null
  
)

export default component.exports